module.exports = __webpack_public_path__ + "static/media/crossWhite.b7b77a03.svg";